import type { AcademyCertification, AcademyEvent, AcademyCollectionContent } from '~/generated_types';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyRecommendedContentKeysForLearner } from './academyRecommendedContentKeyFactory';

type LearnerCardContent =
  | AcademyEvent['LEARNER_CARD_CONTENT']
  | AcademyCertification['LEARNER_CARD_CONTENT']
  | AcademyCollectionContent['LEARNER_CARD_CONTENT'];

export interface RecommendedContentsForExternalUserData {
  id: string;
  uiOrder: number;
  recommendable: LearnerCardContent;
}
export function useGetAcademyRecommendedContentsForExternalUser(
  { academyId }: { academyId: string },
  queryOptions: UseQueryOptions<RecommendedContentsForExternalUserData[]> = {},
) {
  return useQuery<RecommendedContentsForExternalUserData[]>({
    queryKey: academyRecommendedContentKeysForLearner.recommendedContents(academyId),
    queryFn: () => FetchPromise.get(`academy_recommended_contents`),
    ...queryOptions,
  });
}
